import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const events = [
  {
    id: "diciottesimi",
    title: "Diciottesimi",
    desc: "Una festa indimenticabile per un traguardo che arriva una volta sola.",
    img: "/eventi-18.webp",
  },
  {
    id: "compleanni",
    title: "Compleanni",
    desc: "Ogni anno merita un palcoscenico: il vostro è qui.",
    img: "/eventi-compleanni.jpg",
  },
  {
    id: "cerimonie",
    title: "Cerimonie",
    desc: "Comunioni, battesimi e anniversari celebrati con grazia.",
    img: "/eventi-cerimonie.jpg",
  },
  {
    id: "aziendali",
    title: "Eventi Aziendali",
    desc: "Cene di gala, lanci di prodotto e convention con stile impeccabile.",
    img: "/eventi-aziendali.jpg",
  },
];

export default function Eventi() {
  const [active, setActive] = useState(0);

  return (
    <section id="eventi" data-testid="eventi-section" className="bg-midnight px-6 py-28 md:py-40 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.35em] text-dusty">
            <span className="h-px w-10 bg-dusty/70" /> Eventi
          </p>
          <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight text-linen sm:text-5xl md:text-6xl">
            Ogni occasione, <span className="italic text-dusty">il suo palcoscenico</span>.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-12 lg:grid-cols-2 lg:gap-20">
          <div className="flex flex-col">
            {events.map((e, i) => (
              <Reveal key={e.id} delay={i * 0.08}>
                <button
                  data-testid={`event-item-${e.id}`}
                  onMouseEnter={() => setActive(i)}
                  onFocus={() => setActive(i)}
                  onClick={() => window.scrollToSection?.("#contatti")}
                  className={`group flex w-full items-start justify-between gap-6 border-b border-white/10 py-8 text-left transition-colors duration-300 ${
                    active === i ? "text-linen" : "text-linen/40"
                  }`}
                >
                  <div className="flex items-baseline gap-6">
                    <span className={`font-serif text-sm ${active === i ? "text-sand" : "text-linen/30"}`}>
                      0{i + 1}
                    </span>
                    <div>
                      <h3 className="font-serif text-3xl sm:text-4xl">{e.title}</h3>
                      <p
                        className={`mt-2 max-w-sm text-sm font-light transition-opacity duration-300 ${
                          active === i ? "text-linen/60 opacity-100" : "opacity-0"
                        }`}
                      >
                        {e.desc}
                      </p>
                    </div>
                  </div>
                  <ArrowUpRight
                    className={`mt-2 h-5 w-5 shrink-0 transition-all duration-300 ${
                      active === i ? "translate-x-0 text-dusty opacity-100" : "-translate-x-2 opacity-0"
                    }`}
                  />
                </button>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2} className="hidden lg:block">
            <div className="sticky top-28 h-[560px] overflow-hidden" data-testid="event-active-image">
              <AnimatePresence mode="wait">
                <motion.img
                  key={events[active].img}
                  src={events[active].img}
                  alt={events[active].title}
                  initial={{ opacity: 0, scale: 1.06 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                  className="h-full w-full object-cover"
                />
              </AnimatePresence>
              <div className="absolute inset-0 bg-gradient-to-t from-[#060607]/50 to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
